import React, { Fragment } from "react";
import { inject } from "mobx-react";
import { RouterView } from "mobx-state-router";
// import DevTools from 'mobx-react-devtools';
import {
  LoginPanelPage,
  ChangePasswordPanelPage,
  CodeMapPanelPage,
  NotFoundPage
} from "features";

const viewMap = {
  homePanel: <CodeMapPanelPage />,
  loginPanel: <LoginPanelPage />,
  changePasswordPanel: <ChangePasswordPanelPage />,
  codeMapPanel: <CodeMapPanelPage />,

  notFound: <NotFoundPage />
};

@inject("rootStore")
class ShellBase extends React.Component {
  render() {
    const {
      rootStore: { routerStore }
    } = this.props;

    return (
      <Fragment>
        <RouterView routerStore={routerStore} viewMap={viewMap} />
        {/* <DevTools position={{top: 46, left: 25}} /> */}
      </Fragment>
    );
  }
}

export const Shell = ShellBase;
